import React, { useEffect } from "react";
import Avatar from "react-avatar";
import { useSelector } from "react-redux";

export default function ProfilePicture({ id, size, styling, tooltipPosition = "center" }) {
    const { staff } = useSelector((state) => state.auth);

    if (staff?.length > 0) {
        var sender = staff.find((e) => e.id === parseInt(id));
    }

    if (!size) {
        size = 40;
    }

    var styling = styling ? styling : "";
    
    // Tooltip positioning classes based on tooltipPosition prop
    const tooltipClasses = tooltipPosition === "left" 
        ? "absolute right-full mr-2 top-1/2 -translate-y-1/2 w-max"
        : "absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max";
    return (
        <div className={styling}>
            {sender ? (
                sender.profile_picture ? (
                    <div className="relative group">
                        <div className="flex flex-wrap content-center">
                            <img src={sender.profile_picture} className="rounded-full aspect-square object-cover" width={size} />
                        </div>
                        <div className={`${tooltipClasses} px-3 py-1.5 bg-gray-900 text-white text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap pointer-events-none z-[9999]`}>
                            <span className="font-medium">{sender.name} {sender.surname}</span>
                            {tooltipPosition === "center" && (
                                <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
                            )}
                            {tooltipPosition === "left" && (
                                <div className="absolute left-full top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-gray-900"></div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="relative group">
                        <div className="flex flex-wrap content-center">
                            <Avatar name={sender?.name?.charAt(0) + " " + sender.surname?.charAt(0)} size={size} round={true} />
                        </div>
                        <div className={`${tooltipClasses} px-3 py-1.5 bg-gray-900 text-white text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap pointer-events-none z-[9999]`}>
                            <span className="font-medium">{sender.name} {sender.surname}</span>
                            {tooltipPosition === "center" && (
                                <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
                            )}
                            {tooltipPosition === "left" && (
                                <div className="absolute left-full top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-gray-900"></div>
                            )}
                        </div>
                    </div>
                )
            ) : (
                <img src="/images/profile.png" className="rounded-full aspect-square object-cover" width={size} />
            )}
        </div>
    );
}
